import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M950.857 585.143h-365.714v365.714c0 40.229-32.914 73.143-73.143 73.143s-73.143-32.914-73.143-73.143v-365.714h-365.714c-40.229 0-73.143-32.914-73.143-73.143s32.914-73.143 73.143-73.143h365.714v-365.714c0-40.229 32.914-73.143 73.143-73.143s73.143 32.914 73.143 73.143v365.714h365.714c40.229 0 73.143 32.914 73.143 73.143s-32.914 73.143-73.143 73.143z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgPlus);
export default ForwardRef;
